// extracted by mini-css-extract-plugin
export default {"resetButton":"XwM2CdJ","root":"x99crJm","horizontal":"xe9EJU9","vertical":"iQfPVKw"};